module.exports = {"title":"Invoice","description":"Please enter an invoice number to be added.","cancel":"Cancel","confirm":"Confirm"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Payout/InvoiceModal/locales/en.json
// module id = 1952
// module chunks = 0